<template>
  <section id="leistungen">
    <v-container class="leistungen-container">
      <v-row justify="center">
        <h2 class="section-title">{{ lang.leistungen.caption }}</h2>

        <v-spacer class="w-100"></v-spacer>

        <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="justify-center d-flex px-lg-6" v-for="item in lang.leistungen.items"
               :key="item.caption">
          <v-card>
            <v-icon class="icon-bg text-white v-icon--size-large" :icon="item.icon"></v-icon>
            <v-card-title>{{ item.caption }}</v-card-title>
            <v-card-text>{{ item.description }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<style>
.icon-bg {
  background-image: url('/public/images/ihreVorteile/icon-bg.svg');
  padding: 50px;
  background-size: 150px;
  background-repeat: no-repeat;
  background-position: 60% 70%;
}
@media (min-width: 1920px) {
  .leistungen-container {
    padding-left: 200px;
    padding-right: 200px;
  }
}
</style>

<script>
import lang from '@/lang/lang.js'

export default {
  data() {
    return {
      lang: lang,
    }
  }
}
</script>